import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImpulsComponent } from './impuls/impuls.component';
import { KalenderComponent } from './kalender/kalender.component';
import { Page404Component } from './page404/page404.component';

const routes: Routes = [
  { path: '', component: KalenderComponent },
  { path: ':id', component: ImpulsComponent },
  { path: 'vorwort', component: ImpulsComponent },
  { path: 'einleitung', component: ImpulsComponent },
  { path: '**', component: Page404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
